module.exports = __webpack_public_path__ + "img/20190523205856微信截图_20190523210251.4cacadc5.png";